package ui.demoMerchantAdmin

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import ui.consumerInformation.ConsumerCardDisplayColumn

@Composable
fun DemoMerchantAdminScreen(
    viewModel: DemoMerchantViewModel = demoMerchantViewModel()
) {
    val shouldShowScrollbar = viewModel.clientConfig.shouldShowScrollBar
    val cardStateFlow = viewModel.cardDeleteStateFlow

    Column(modifier = Modifier.fillMaxSize()) {
        val _cardList by cardStateFlow.collectAsState()
        val cardList = _cardList
        ConsumerCardDisplayColumn(
            cardList?.cards?.filterNotNull() ?: emptyList(),
            shouldShowScrollbar,
            cardStateFlow,
            viewModel::loadDeleteCardAsync
        ) { card ->
            viewModel.deleteCard(card)
        }
    }
}
